module.exports = __webpack_public_path__ + "static/media/right.c52c4d26.svg";